export const DEFAULT_CONCENTRATION_KEY = 'default';
export const DEFAULT_CONCENTRATION_LIMITS = { defaultValue: 0, max: 0, min: 0 };
